import React from "react";
import Grid from "../../GridCards/Grid";
const InventarioPadre = () => {
  return <Grid />;
};

export default InventarioPadre;
